// src/components/WhatsAppButton.js
import React, { useState, useEffect } from "react";
import "../../index.css";
import imgWhatsApp from "../../assets/img/whatsApp.svg";

const WhatsAppButton = ({course}) => {

  const phoneNumber = "573014953565";

  const message = course ? encodeURIComponent(`Quiero inscribirme en el ${course.typeTitle} de "${course.titleMain}" con la promoción de la página web pero aún tengo dudas y quisiera resolverlas`) : encodeURIComponent(`Hola, vengo del sitio web y me interesan sus cursos pero aún tengo dudas y quisiera resolverlas`);
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  // 1. Estado para controlar la visibilidad de los botones
  const [isVisible, setIsVisible] = useState(false);

  // 2. Función que se ejecuta al hacer scroll
  const toggleVisibility = () => {
    // Si el scroll vertical es mayor a 300px, muestra los botones
    if (window.scrollY > 1500) {
      setIsVisible(true);
    } else {
      // De lo contrario, ocúltalos
      setIsVisible(false);
    }
  };

  // Función para subir al inicio (sin cambios)
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // 3. useEffect para añadir y remover el "escucha" del scroll
  useEffect(() => {
    // Añadimos el event listener cuando el componente se monta
    window.addEventListener("scroll", toggleVisibility);

    // Es importante remover el listener cuando el componente se desmonta
    // para evitar problemas de rendimiento.
    return () => {
      window.removeEventListener("scroll", toggleVisibility);
    };
  }, []); // El array vacío asegura que esto se ejecute solo una vez

  return (
    // 4. Usamos el estado 'isVisible' para añadir o quitar una clase CSS
    <div className={`floating-buttons ${isVisible ? "visible" : ""}`}>
      {/* Botón para subir al inicio */}
      <button className="scroll-top-btn" onClick={scrollToTop}>
        <i className="fa fa-angle-double-up"></i>
      </button>

      {/* Botón de WhatsApp */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-btn"
      >
        <img
          src={imgWhatsApp}
          alt="WhatsApp"
        />
      </a>
    </div>
  );
};

export default WhatsAppButton;
